/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePenaltyCommand } from '../../models/create-penalty-command';
import { CreatePenaltyCommandResult } from '../../models/create-penalty-command-result';

export interface ApiPenaltiesCreatePenaltyPost$Params {
      body?: CreatePenaltyCommand
}

export function apiPenaltiesCreatePenaltyPost(http: HttpClient, rootUrl: string, params?: ApiPenaltiesCreatePenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltiesCreatePenaltyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePenaltyCommandResult>;
    })
  );
}

apiPenaltiesCreatePenaltyPost.PATH = '/api/Penalties/CreatePenalty';
